import styled from 'styled-components';

import { ToastBanner } from '../..';

import { CartItemsCount, CartItemsCountContainer } from './styles';

interface ViewOrderToastProps {
  cartItemCount: number;
}

export const Image = styled.img``;

export const ViewOrderToast = ({ cartItemCount }: ViewOrderToastProps) => {
  return (
    <ToastBanner text={'View Order'} textVariant={'calloutSmall'} variant={'viewOrder'} medicationsHomepageHack={true}>
      <CartItemsCountContainer>
        <Image src="/public/Bag.svg" alt="" />
        <CartItemsCount>{cartItemCount}</CartItemsCount>
      </CartItemsCountContainer>
    </ToastBanner>
  );
};
